import type { MaybeRefOrGetter } from "vue";

type JsonLdDocument = Record<string, unknown>;

export function useJsonLd(source: MaybeRefOrGetter<JsonLdDocument | null | undefined>) {
  useHead({
    script: () => {
      const document = toValue(source);
      if (!document) return [];
      return [{ type: "application/ld+json", innerHTML: serializeJsonLd(document) }];
    },
  });
}
